// import React from 'react';
// import { Typography, Box } from '@mui/material';

// const ProfileHeader: React.FC = () => {
//   return (
//     <Box
//       sx={{
//         mb: 4,
//         textAlign: { xs: 'center', sm: 'left' },
//       }}
//     >
//       <Typography
//         variant="h3"
//         sx={{
//           fontSize: { xs: '28px', sm: '32px' },
//           fontWeight: 'bold',
//           color: '#212529',
//           letterSpacing: '-0.5px',
//         }}
//       >
//         Profile
//       </Typography>
//     </Box>
//   );
// };

// export default ProfileHeader;
import React from 'react';
import { Box, Typography } from '@mui/material';

const ProfileHeader: React.FC = () => {
  return (
    <Box
      sx={{
        marginBottom: 3,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: '#212529',
          fontWeight: 600,
          fontSize: { xs: '24px', sm: '28px', md: '32px' },
        }}
      >
        Profile
      </Typography>
    </Box>
  );
};

export default ProfileHeader;